import type { Sf2RuntimeBank, Sf2Zone } from "../types";

/** Resolve the first matching zone for a note (kernel-safe; no SF2 parser deps). */
export function findSf2Zone(
  bank: Sf2RuntimeBank,
  midiBank: number,
  program: number,
  midi: number,
  velocityMidi: number,
): Sf2Zone | undefined {
  let fallback: Sf2Zone | undefined;
  for (const zone of bank.zones) {
    if (zone.bank !== midiBank || zone.program !== program) {
      continue;
    }
    if (midi < zone.keyLo || midi > zone.keyHi) {
      continue;
    }
    if (velocityMidi >= zone.velLo && velocityMidi <= zone.velHi) {
      return zone;
    }
    fallback ??= zone;
  }
  return fallback;
}
